/* unplugin-vue-components disabled */import { render } from "./AppDrawer.vue?vue&type=template&id=31f7850f&ts=true"
import script from "./AppDrawer.vue?vue&type=script&lang=ts"
export * from "./AppDrawer.vue?vue&type=script&lang=ts"

import "./AppDrawer.vue?vue&type=style&index=0&id=31f7850f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__